import _ from "lodash";
import React, { useEffect, useState } from "react";
import CardOutlet from "../../components/Card/CardOutlet";
import ModalOutlet from "../../components/Modal/ModalOutlet";
import ModalLoading from "../../components/ModalLoading";
import ModalDelete from "../../components/Modal/ModalDelete";
import {
  requestDelete,
  requestGet,
  requestPost,
  requestPut,
} from "../../api/coreInstance";
import useAPI from "../../hooks/useAPI";

export default function OutletDetailsFragment({ dataAccount, token }) {
  const [outlets, loadingOutlet, fetchOutlets] = useAPI(
    "/outlets",
    {
      retailer: dataAccount?.id,
      limit: 10000,
    },
    { Authorization: `Bearer ${token}` },
  );

  // state modal
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);
  const [showModalLoading, setShowModalLoading] = useState(false);
  const [showModalOutlet, setShowModalOutlet] = useState(false);
  const [modalOutletDetails, setModalOutletDetails] = useState({
    title: "Add Outlet",
    type: "Add",
  });

  // state loading
  const [buttonLoading, setButtonLoading] = useState(false);

  // state input outlet
  const [inputOutlet, setInputOutlet] = useState({});

  function generateRandomNumber() {
    // Generate a random number between 0 and 1 (excluding 1)
    const randomDecimal = Math.random();

    // Scale the random number to be between 1000 and 9999
    const randomNumber = Math.floor(randomDecimal * 9000) + 1000;

    return randomNumber;
  }

  async function AddOutlet() {
    setShowModalLoading(true);
    // field_required
    let body = {
      outlet_kartini_code: `DOMPET${generateRandomNumber()}`,
      channel_id: outlets.channel_id,
      status: "active",
      validation_status: "to be confirmed",
      ...inputOutlet,
    };

    await requestPost(
      `${process.env.REACT_APP_BASE_URL_API}/outlet/kartini`,
      body,
    ).catch((error) => {
      console.error(error);
      setShowModalLoading(false);
    });
    fetchOutlets();
    setShowModalOutlet(false);
    setShowModalLoading(false);
  }

  async function EditOutlet(body) {
    setShowModalLoading(true);
    await requestPut(`/outlet/kartini/${body.outlet_kartini_id}`, body).catch(
      (error) => {
        console.error(error);
        setShowModalLoading(false);
      },
    );
    fetchOutlets();
    setShowModalOutlet(false);
    setShowModalLoading(false);
  }

  async function ShowDeleteModal(id) {
    setModalOutletDetails({
      title: "Delete Outlet",
      type: "Delete",
      id: id,
    });
    setShowDeleteConfirmationModal(true);
  }

  async function DeleteOutlet() {
    setButtonLoading(true);
    let id = modalOutletDetails.id;
    await requestDelete(`/outlet/kartini/${id}`).catch((error) => {
      console.error(error);
      setButtonLoading(false);
      setShowDeleteConfirmationModal(false);
    });
    fetchOutlets();
    setButtonLoading(false);
    setShowDeleteConfirmationModal(false);
  }

  function ShowEditModal(data) {
    setInputOutlet(data);
    setShowModalOutlet(true);
    setModalOutletDetails({
      title: "Edit Outlet",
      type: "Edit",
    });
  }

  return (
    <>
      <ModalDelete
        title="Outlet"
        showDeleteConfirmationModal={showDeleteConfirmationModal}
        setShowDeleteConfirmationModal={setShowDeleteConfirmationModal}
        DeleteFunction={DeleteOutlet}
        buttonLoading={buttonLoading}
      />
      <ModalLoading
        showModal={showModalLoading}
        setShowModal={setShowModalLoading}
      />
      <ModalOutlet
        modalOutletDetails={modalOutletDetails}
        showModal={showModalOutlet}
        setShowModal={setShowModalOutlet}
        inputOutlet={inputOutlet}
        setInputOutlet={setInputOutlet}
        outlets={outlets}
        functionAdd={AddOutlet}
        functionEdit={EditOutlet}
      />

      <div className="overflow-y-scroll">
        <div className="space-y-3">
          {_.isEmpty(outlets) ? (
            <div className="h-28 w-full border-2 border-dashed">
              <div className="flex h-full w-full items-center justify-center space-x-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className={`h-5 w-5 text-gray-400 ${loadingOutlet && "animate-pulse"}`}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M13.5 21v-7.5a.75.75 0 01.75-.75h3a.75.75 0 01.75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349m-16.5 11.65V9.35m0 0a3.001 3.001 0 003.75-.615A2.993 2.993 0 009.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 002.25 1.016c.896 0 1.7-.393 2.25-1.016a3.001 3.001 0 003.75.614m-16.5 0a3.004 3.004 0 01-.621-4.72L4.318 3.44A1.5 1.5 0 015.378 3h13.243a1.5 1.5 0 011.06.44l1.19 1.189a3 3 0 01-.621 4.72m-13.5 8.65h3.75a.75.75 0 00.75-.75V13.5a.75.75 0 00-.75-.75H6.75a.75.75 0 00-.75.75v3.75c0 .415.336.75.75.75z"
                  />
                </svg>
                <span
                  className={`text-sm text-gray-400 ${loadingOutlet && "animate-pulse"}`}
                >
                  {loadingOutlet ? "Loading..." : "You don't have an outlet"}{" "}
                </span>
              </div>
            </div>
          ) : (
            outlets.map((outlet, i) => (
              <CardOutlet
                data={outlet}
                enActionEdit={true}
                isDisable={true}
                editFunction={ShowEditModal}
                deleteFunction={ShowDeleteModal}
              />
            ))
          )}
        </div>
      </div>
    </>
  );
}
